export default __webpack_public_path__ + "static/media/wolf.d8bb89d5.png";